<template>
    <session class="page-register" :class="{ ffen: getLocalLangCode() != 'zh' }">
        <div class="register-block-wrapper">
            <div class="register-block">
                <div class="register-bg" :class="{bg_person: customerType === 'person', bg_enterprise: customerType === 'enterprise',bg_agent: customerType === 'agent'}">
                    <div v-for="(item) in entrancesList">
                        <div v-if="item.id === customerType">
                            <p>{{ item.title }}</p>
                            <p class="subtext">{{ item.desc }}</p>
                        </div>
                    </div>
                </div>
                <div class="register-block-l" v-if="step == 1">
                    <div class="register-block-title">{{LOCAL('register_title')}}</div>
                    <div class="register-block-info-wrapper">
                        <div class="register-block-info-input">
                            <div><span class="required">*</span>{{LOCAL('register_account')}}</div>
                            <input type="text" v-model="username" @blur="checkUsername" @input="nocheckUsername" maxlength="20" autofocus>
                        </div>
                        <div class="register-block-info-tip" :class="{error: errorUsername}">
                            <Icon v-if="correctUsername" name="correct" size="16"/>
                            <Icon v-if="errorUsername" name="error" size="16"/><span v-if="!correctUsername">{{LOCAL('register_account_tip')}}</span></div>
                    </div>
                    <div class="register-block-info-wrapper">
                        <div class="register-block-info-input">
                            <div><span class="required">*</span>{{LOCAL('register_email')}}</div>
                            <input type="text" v-model="email" @blur="validateEmail" @input="nocheckEmail">
                        </div>
                        <div class="register-block-info-tip" :class="{error: errorEmail}">
                            <Icon v-if="correctEmail" name="correct" size="16"/>
                            <Icon v-if="errorEmail" name="error" size="16"/><span v-if="!correctEmail">{{LOCAL('register_email_tip')}}</span></div>
                    </div>
                    <div class="register-block-info-wrapper">
                        <div class="register-block-info-input">
                            <div><span class="required">*</span>{{LOCAL('register_password')}}</div>
                            <input :type="showPassword ? 'text' : 'password'" v-model="password" @input="showVisible" @blur="validatePassword" maxlength="20">
                            <Icon v-if="startInput" :name="showPassword ? 'pass_0' : 'pass_1'" size="24" @click="viewPassword" class="icon-visible"/>
                        </div>
                        <div class="register-block-info-tip" :class="{error: errorPassword}">
                            <Icon v-if="correctPassword" name="correct" size="16"/>
                            <Icon v-if="errorPassword" name="error" size="16"/><span v-if="!correctPassword">{{LOCAL('register_password_tip')}}</span></div>
                    </div>
                    <div class="register-block-info-wrapper">
                        <div class="register-block-info-input">
                            <div><span class="required">*</span>{{LOCAL('register_password_again')}}</div>
                           <input :type="showConfirmPassword ? 'text' : 'password'" v-model="confirmPassword" @input="showConfirmVisible" @blur="validateConfirmPassword" maxlength="20">
                           <Icon v-if="startInput2" :name="showConfirmPassword ? 'pass_0' : 'pass_1'" size="24" @click="viewConfirmPassword" class="icon-visible"/>
                        </div>
                        <div class="register-block-info-tip" v-if="errorConfirmPassword && correctPassword && !isReset"  :class="{error: errorConfirmPassword}">
                            
                            <Icon name="error" size="16"/>{{LOCAL('register_password_again_error')}}</div>
                            <div class="register-block-info-tip" v-if="correctConfirmPassword && correctPassword && !isReset"><Icon  name="correct" size="16"/></div>
                            
                    </div>
                    <div class="register-block-info-wrapper">
                        <div class="register-block-info-input">
                            <div><span class="required">*</span>{{LOCAL('register_promo_code')}}</div>
                            <input type="text" v-model="promoCode" @input="checkPromoCode" maxlength="10">
                        </div>
                        <div class="register-block-info-tip" v-if="errorPromoCode" :class="{error: errorPromoCode}"><Icon name="error" size="16"/>{{LOCAL('register_promo_code_error')}}</div>
                    </div>
                    <div class="register-block-btn-group">
                        <div class="register-block-btn-cancel" @click="goBack">{{ LOCAL('register_cancel_btn') }}</div>
                        <button class="register-block-btn-next" :class="{active: correctUsername && correctEmail && correctPassword && correctConfirmPassword && hasPromoCode}" @click="validatePromoCode" :disabled="errorUsername || errorEmail || errorPassword || errorConfirmPassword || errorPromoCode || !hasPromoCode">{{ LOCAL('next') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </session>
</template>
  
<script setup>
import { ref, onMounted,watchEffect } from 'vue';
import * as Utils from '@/assets/utils';
import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
import Icon from '@/components/icon/index.vue';
import router from '@/router';
import Footer from '@/components/footer/index.vue';
import { useRoute } from 'vue-router'


const route = useRoute();
let customerType = ref(route.query.plan)
// 流出步骤
const step = ref(1);  // 1 - 第一步；2 - 第二步
// 入口列表

const entrancesList = [
    { title: LOCAL('login_loginType_1_title'), desc: LOCAL('login_loginType_1_desc'), icon: 'person', id: 'person' },
    { title: LOCAL('login_loginType_2_title'), desc: LOCAL('login_loginType_2_desc'), icon: 'enterprise', id: 'enterprise' },
    { title: LOCAL('login_loginType_3_title'), desc: LOCAL('login_loginType_3_desc'), icon: 'agent', id: 'agent' },
]


const username = ref('');
let errorUsername = ref(false);
let correctUsername = ref(false)

const email = ref('');
let errorEmail = ref(false);
let correctEmail = ref(false)

const password = ref('')
let showIcon = ref(false)
let showPassword = ref(false)
let errorPassword = ref(false)
let correctPassword = ref(false)

let startInput = ref(false)
let startInput2 = ref(false)


const confirmPassword = ref('')
let showConfirmIcon = ref(false)
let showConfirmPassword = ref(false)
let correctConfirmPassword = ref(false)
let isReset = ref(false)
let errorConfirmPassword = ref(false)

const promoCode = ref('')
let hasPromoCode = ref(false)
let errorPromoCode = ref(false)


const checkUsername = () => {
    if (!/^[\w]{3,20}$/.test(username.value)) {
        errorUsername.value = true
        correctUsername.value = false
    } else {
        errorUsername.value = false
        correctUsername.value = true
    }
}

const nocheckUsername = () => {
    errorUsername.value = false
}

const validateEmail = () => {
    if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email.value)) {
        errorEmail.value = true
        correctEmail.value = false
    } else {
        errorEmail.value = false
        correctEmail.value = true
    }
}

const nocheckEmail = () => {
    errorEmail.value = false
}

const showVisible = (e) => {
    if(e.target.value.length > 0){
        startInput.value = true
    } else {
        startInput.value = false
        showPassword.value = false
    }
    confirmPassword.value = ''
    isReset.value = true
    errorPassword.value = false
}

const showConfirmVisible = (e) => {
    if(e.target.value.length > 0){
        startInput2.value = true
    } else {
        startInput2.value = false
        showConfirmPassword.value = false
    }
    errorConfirmPassword.value = false
}

const viewPassword = () => {
    showPassword.value = !showPassword.value
}

const viewConfirmPassword = () => {
    showConfirmPassword.value = !showConfirmPassword.value
}

const validatePassword = () => {
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{7,}$/.test(password.value)) {
        errorPassword.value = true
        correctPassword.value = false
    } else {
        errorPassword.value = false
        correctPassword.value = true
    }
    
}

const validateConfirmPassword = () => {
    isReset.value = false
    if(correctPassword.value){
        if (password.value !== confirmPassword.value) {
        errorConfirmPassword.value = true
        correctConfirmPassword.value = false
        } else {
            errorConfirmPassword.value = false
            correctConfirmPassword.value = true
        }
    }
    
}

const checkPromoCode = (e) => {
    if(e.target.value.length > 0){
        hasPromoCode.value = true
    } else {
        hasPromoCode.value = false
    }
    errorPromoCode.value = false
}

const validatePromoCode = () => {
    errorPromoCode.value = true
    hasPromoCode.value = false
}

const goBack = () => {
    router.go(-1)
}

// 监听路由变化并更新message
watchEffect(() => {
    customerType = route.query.plan;
});

onMounted(()=> {
    step.value = 1;
    if (!route.query.plan){
        router.replace(
      { 
        path: '/register', 
        query: {
          plan: 'person'
        }  
      });
    }
})
  
  </script>

<style scoped lang="less">
    @import "index.less";
</style>
